import { faPlus } from '@fortawesome/pro-regular-svg-icons'
import { Button, Flex, Title } from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import { Alert, Icon } from '@flecto/ui'
import { Page } from '@flecto/ui/saas'

import { useModalCategoryUpdate } from '../../categories'
import { useFlattenItemCategories } from '../../categories/hooks/useFlattenItemCategories'
import { TableCategories } from '../components/TableCategories/TableCategories'

export function PageInventory() {
  const { categories: items } = useFlattenItemCategories()
  const { openModal: openCategoryUpdateModal } = useModalCategoryUpdate()

  const { t } = useTranslation('saas', { keyPrefix: 'profile_inventory' })

  return (
    <Page>
      <Page.Title>{t('title')}</Page.Title>
      <Page.Content>
        <Alert
          description={t('alert_description')}
          mb='lg'
          title={t('alert_title')}
          variant='info'
        />
        <Flex
          align='center'
          gap='md'
          justify='space-between'
          mb='lg'
          wrap='wrap'
        >
          <Title order={4}>{t('subtitle')}</Title>
          <Flex gap='md'>
            <Button
              leftSection={<Icon icon={faPlus} />}
              onClick={() => openCategoryUpdateModal()}
              size='sm'
            >
              {t('btn_new_category')}
            </Button>
          </Flex>
        </Flex>

        <TableCategories items={items} />
      </Page.Content>
    </Page>
  )
}
